import React from 'react'

interface CasingShoeProps {
    x: string | number
}

export const CasingShoeBullet = React.forwardRef<SVGSVGElement, CasingShoeProps>(function CasingTip1(
    { x }: CasingShoeProps,
    ref
): JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="29"
            x={x ?? '18.5'}
            y="588.576"
            fill="none"
            ref={ref}
            className="casing-shoe casing-shoe--2"
            version="1.1"
            viewBox="0 0 15 29"
            xmlSpace="preserve"
        >
            <path
                fill="#252c38"
                fillOpacity="0.999"
                stroke="none"
                strokeOpacity="1"
                strokeWidth="6.738"
                d="M1.8.561v18.33h.02C2.013 22.934 3.94 28.303 6.534 29c2.328-1.103 4.973-5.185 6.337-7.838.21-.35.287-1.366.314-2.271h.015V.56z"
                display="inline"
            ></path>
        </svg>
    )
})

export const CasingShoe = React.forwardRef<SVGSVGElement, CasingShoeProps>(function CasingTip1(
    { x }: CasingShoeProps,
    ref
): JSX.Element {
    return (
        <svg
            ref={ref}
            className="casing-shoe casing-shoe--2"
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="29"
            x={x ?? '18.5'}
            y="587.576"
            fill="none"
            version="1.1"
            viewBox="0 0 15 29"
            xmlSpace="preserve"
        >
            <path
                fill="#252c38"
                fillOpacity="0.999"
                stroke="none"
                strokeOpacity="1"
                strokeWidth="7.364"
                d="M1.8.56v24.582h.005L1.8 25.2c0 2.265 2.553 3.8 5.7 3.8 3.147 0 5.7-1.535 5.7-3.8 0-.02-.001-.039-.003-.058h.003V.56z"
                display="inline"
            ></path>
        </svg>
    )
})
